import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d96ce6d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-manager" }
const _hoisted_2 = { class: "account-manager__head" }
const _hoisted_3 = { class: "account-manager__body" }
const _hoisted_4 = { class: "account-manager__content" }
const _hoisted_5 = { class: "account-manager__title" }
const _hoisted_6 = { class: "h5" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "account-manager__content" }
const _hoisted_11 = { class: "account-manager__title" }
const _hoisted_12 = { class: "account-manager__languages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.initials), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.managerLabel" })
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.accountManager?.firstname) + " " + _toDisplayString(_ctx.accountManager?.lastname), 1),
        (_ctx.accountManager?.email)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "account-manager__link",
              href: `mailto:${_ctx.accountManager?.email}`
            }, _toDisplayString(_ctx.accountManager.email), 9, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.accountManager?.phone)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "account-manager__link",
              href: `tel:${_ctx.accountManager?.phone}`
            }, _toDisplayString(_ctx.accountManager.phone), 9, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.accountManager?.phone_mobile)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "account-manager__link",
              href: `tel:${_ctx.accountManager?.phone_mobile}`
            }, _toDisplayString(_ctx.accountManager.phone_mobile), 9, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.language" })
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountManager?.supported_languages, (lang) => {
            return (_openBlock(), _createElementBlock("div", {
              key: lang.id,
              class: "button button--outline button--sm"
            }, _toDisplayString(lang.name), 1))
          }), 128))
        ])
      ])
    ])
  ]))
}